$(document).ready(function() {
    $('#mail').on('submit', function(e) {
        e.preventDefault();
        const formData = $(this).serializeArray();
        ajax(formData);
    });
    return false;
});

function ajax(formData) {
    $.ajax({
        url: '/api/internal/lost-pass/',
        type: 'post',
        cache: false,
        data: { formData },
        dataType: 'json',
        success(data) {
            console.log(data);
            if (data === true) {
                $('#title').html('Проверьте почтовый ящик');
                $('#descr').html('Мы отправили ссылку на восстановление пароля на указанный вами Email');
            } else {
                $('#descr').html('Такой e-mail не зарегистрирован');
            }
        },
    });
}
